import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const EventsContext = createContext();

export const EventsProvider = ({ children }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const parseDotNetDate = (dotNetDate) => {
    if (!dotNetDate) return new Date();
    const timestamp = parseInt(dotNetDate.replace(/[^0-9]/g, ""));
    return new Date(timestamp);
  };

  const formatDate = (dotNetDate) => {
    const date = parseDotNetDate(dotNetDate);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  };

  // Group by Year → Month
const groupEvents = (data) => {
  // ✅ Sort strictly by EventDate
  const sorted = [...data].sort((a, b) => {
    const dateA = parseDotNetDate(a.EventDate);
    const dateB = parseDotNetDate(b.EventDate);
    return dateB - dateA;
  });

  const grouped = {};

  sorted.forEach(item => {
    if (!item.EventDate) return; // 🔥 ignore invalid items

    const date = parseDotNetDate(item.EventDate);
    const year = date.getFullYear();
    const monthIndex = date.getMonth();
    const monthName = date.toLocaleString("default", { month: "long" });

    if (!grouped[year]) grouped[year] = {};

    if (!grouped[year][monthIndex]) {
      grouped[year][monthIndex] = {
        month: monthName,
        events: []
      };
    }

    grouped[year][monthIndex].events.push({
      _id: item.Id,
      title: item.Title,
      Banner_Img: item.Banner_Img,
      images: item.Images ? item.Images.split(",") : []
    });
  });

  return Object.keys(grouped)
    .sort((a, b) => b - a) // latest year first
    .map(year => ({
      year,
      months: Object.keys(grouped[year])
        .sort((a, b) => b - a) // latest month first
        .map(monthIndex => grouped[year][monthIndex])
    }));
};

  const [groupedEvents, setGroupedEvents] = useState([]);

  // Fetch all events
  const fetchEvents = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/Home/GetEventsApi`
      );

      if (res.data.status === "Success") {
        const rawData = res.data.data;
        
        // Grouped for main Events page
        setGroupedEvents(groupEvents(rawData));

        // Formatted for slider
        const sorted = [...rawData].sort((a, b) => {
          const dateA = parseDotNetDate(a.EventDate || a.Created_Date);
          const dateB = parseDotNetDate(b.EventDate || b.Created_Date);
          return dateB - dateA;
        });

        const formatted = sorted.map(item => ({
          ...item,
          formattedDate: formatDate(item.EventDate || item.Created_Date),
          link: `/events/${item.Id}`
        }));

        setEvents(formatted);
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch events on component mount
  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <EventsContext.Provider value={{ events, groupedEvents, loading, fetchEvents }}>
      {children}
    </EventsContext.Provider>
  );
};

export const useEvents = () => useContext(EventsContext);